import { chatsRepository } from "@/infrastructure/proposals/proposals.repository";

export const submitRequestRevisionUseCase = async ({ uuid_chat_deal, revision_text }) => {
  if (!revision_text || revision_text.trim() === "") {
    throw new Error("NEED_TEXT");
  }
  return chatsRepository.requestRevisionChat(uuid_chat_deal, revision_text);
};

export const submitAcceptContentsUseCase = async ({ uuid_chat_deal, accept_contents }) => {
  if (!accept_contents) {
    throw new Error("NEED_CONFIRM");
  }
  return chatsRepository.acceptContents(uuid_chat_deal);
};

export const submitRequestRevisionLinksUseCase = async ({ uuid_chat_deal, revision_text }) => {
  if (!revision_text || revision_text.trim() === "") {
    throw new Error("NEED_TEXT");
  }
  return chatsRepository.requestRevisionLinks(uuid_chat_deal, revision_text);
};

export const submitAcceptLinksUseCase = async ({ uuid_chat_deal, accept_links }) => {
  if (!accept_links) {
    throw new Error("NEED_CONFIRM");
  }
  return chatsRepository.acceptLinks(uuid_chat_deal);
};
export const submitRequestDealsPaid = async ({ uuid_chat_deal }) => {
  return chatsRepository.getDealsPaid(uuid_chat_deal);
};
export const submitRequestMessageChatDeal = async ({ uuid_chat_deal }) => {
  return chatsRepository.getMessageChatDeal(uuid_chat_deal);
};